import Reflux from "reflux";
import { qualifyUrl } from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
import ApiRoutes from "routing/ApiRoutes";
import { singletonStore } from "logic/singleton";
import { PreferencesActions } from "stores/users/PreferencesStore";
import { SessionActions, SessionStore } from "stores/sessions/SessionStore";
import { StartpageStore } from "stores/users/StartpageStore";
export const CurrentUserStore = singletonStore(
  "core.CurrentUser",
  () => Reflux.createStore({
    listenables: [SessionActions],
    currentUser: void 0,
    init() {
      this.listenTo(SessionStore, this.sessionUpdate, this.sessionUpdate);
      this.listenTo(StartpageStore, this.reload, this.reload);
      PreferencesActions.saveUserPreferences.completed.listen(this.reload);
    },
    getInitialState() {
      return { currentUser: this.currentUser };
    },
    get() {
      return this.currentUser;
    },
    sessionUpdate(sessionInfo) {
      if (sessionInfo.username) {
        const { username } = sessionInfo;
        this.update(username);
      } else {
        this.currentUser = void 0;
        this.trigger({ currentUser: this.currentUser });
      }
    },
    reload() {
      if (this.currentUser !== void 0) {
        return this.update(this.currentUser.username);
      }
      return Promise.resolve();
    },
    update(username) {
      return fetch(
        "GET",
        qualifyUrl(ApiRoutes.UsersApiController.loadByUsername(encodeURIComponent(username)).url)
      ).then((resp) => {
        this.currentUser = resp;
        this.trigger({ currentUser: this.currentUser });
        return resp;
      });
    }
  })
);
